import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined';
import MuiTab from '@mui/material/Tab';
import type { ComponentProps } from 'react';

interface Props extends Omit<
  ComponentProps<typeof MuiTab>,
  'iconPosition' | 'icon'
> {
  inError?: boolean;
}

export const EditOrderTab = ({ inError, ...props }: Props) => {
  return (
    <MuiTab
      iconPosition="end"
      icon={inError ? <ErrorOutlineOutlined color="error" /> : undefined}
      {...props}
    />
  );
};
